import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'sync',
    loadChildren: () => import('./pages/sync/sync.module').then(m => m.SyncPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'routes',
    loadChildren: () => import('./pages/routes/routes.module').then(m => m.RoutesPageModule)
  },
  {
    path: 'routes/schedule',
    loadChildren: () => import('./pages/route-schedule/route-schedule.module').then(m => m.RouteSchedulePageModule)
  },
  {
    path: 'routes/create/:id',
    loadChildren: () => import('./pages/route-modify/route-modify.module').then(m => m.RouteModifyPageModule)
  },
  {
    path: 'routes/modify/:id',
    loadChildren: () => import('./pages/route-modify/route-modify.module').then(m => m.RouteModifyPageModule)
  },
  {
    path: 'routes/details/:id',
    loadChildren: () => import('./pages/route-details/route-details.module').then(m => m.RouteDetailsModule)
  },
  {
    path: 'routes/:status/:routeId/:siteViewType/:siteId',
    loadChildren: () => import('./pages/site-details/site-details.module').then(m => m.SiteDetailsModule)
  },
  {
    path: 'pdf-preview/:fileURL',
    loadChildren: () => import('./pages/pdf-preview/pdf-preview.module').then(m => m.PdfPreviewModule)
  },
  {
    path: 'routes/sites/:routeId/visit/:id/:type',
    loadChildren: () => import('./pages/visit/visit.module').then(m => m.VisitModule)
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/inventory.module').then(m => m.InventoryModule)
  },
  {
    path: 'inventory-transfer',
    loadChildren: () => import('./pages/inventory-transfer/inventory-transfer.module').then(m => m.InventoryTransferModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then(m => m.HistoryModule)
  },
  {
    path: 'clock-in-history',
    loadChildren: () => import('./pages/clock-in-history/clock-in-history.module').then(m => m.ClockInHistoryModule)
  },
  {
    path: 'site-visit/:id',
    loadChildren: () => import('./pages/site-visit/site-visit.module').then(m => m.SiteVisitModule)
  },
  {
    path: 'tasks',
    loadChildren: () => import('./pages/tasks/tasks.module').then(m => m.TasksModule)
  },
  {
    path: 'site-lookup',
    loadChildren: () => import('./pages/site-lookup/site-lookup.module').then(m => m.SiteLookupPageModule)
  },
  {
    path: 'site-lookup/:id',
    loadChildren: () => import('./pages/site-lookup-details/site-lookup-details.module').then(m => m.SiteLookupDetailsPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
